import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ShapeStarIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M22.44 8.68L16.42 13.48L18.46 20.96L12.02 16.68L5.56 20.96L7.6 13.48L1.58 8.68L9.28 8.3L12.02 1.12L14.74 8.3L22.44 8.68ZM15.88 17.3L14.52 12.76L18.26 9.94L13.58 9.78L12.02 5.4L10.44 9.78L5.76 9.94L9.5 12.76L8.14 17.3L12.02 14.58L15.88 17.3Z" />
    </SvgIcon>
  );
});
